import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AgentState } from "../states/agent.state";

export const selectAgentState =
  createFeatureSelector<AgentState>("agent");

export const selectAgent = createSelector(
  selectAgentState,
  (state) => state.agentList
);

export const selectAgentLoading = createSelector(
    selectAgentState,
  (state) => state.loading
);

export const selectAgentError = createSelector(
    selectAgentState,
  (state) => state.error
);
